import { useInfiniteQuery } from '@tanstack/react-query';
import {
  payCalendarsService,
  FetchPayCalendarsRequest,
  FetchPayCalendarsResponse,
  useToast,
} from '@aslanpay/portal-common-lib';

type UseFetchPayCalendarsProps = Omit<FetchPayCalendarsRequest, 'page'> & {
  size: number;
};

const useFetchInfinitePayCalendars = (
  {
    ids,
    status,
    payFrequency,
    payday,
    payType,
    companyId,
    friendlyId,
    startDateBefore,
    startDateAfter,
    query,
    sortBy,
    sort,
    size,
  }: UseFetchPayCalendarsProps,
  enabled = true
) => {
  const toast = useToast();

  return useInfiniteQuery<FetchPayCalendarsResponse, Error>({
    queryKey: [
      'fetchPayCalendars',
      ids,
      status,
      payFrequency,
      payday,
      payType,
      companyId,
      friendlyId,
      startDateBefore,
      startDateAfter,
      query,
      sortBy,
      sort,
      size,
    ],
    queryFn: ({ pageParam = 0 }) =>
      payCalendarsService.fetchPayCalendars({
        ids,
        status,
        payFrequency,
        payday,
        payType,
        companyId,
        friendlyId,
        startDateBefore,
        startDateAfter,
        query,
        sortBy,
        sort,
        page: pageParam,
        size,
      }),
    getNextPageParam: (lastPage) => {
      const hasMore = (lastPage.pageNumber + 1) * lastPage.pageSize < lastPage.total;
      return hasMore ? lastPage.pageNumber + 1 : undefined;
    },
    enabled,
    onError: () => {
      toast({
        position: 'top-right',
        status: 'error',
        title: 'Something went wrong',
        description: 'Sorry, we failed to fetch the pay calendars. Please try again.',
      });
    },
  });
};

export default useFetchInfinitePayCalendars;
